import urlParse from 'url-parse';
import * as routes from '@trello/routes';

const matchers: Record<string, string> = {
  [routes.ACCOUNT]: '^([^/]+)/account$',
  [routes.BILLING]: '^([^/]+)/billing(?:\\?(.*?))?$',
  [routes.BILLING_CARD]: '^([^/]+)/billing/card$',
  [routes.BILLING_CARD_PRODUCT]: '^([^/]+)/billing/card/([^/]+)$',
  [routes.BLANK]: '^blank$',
  [routes.BOARD]: '^b/([^/]+)(?:/(.*?))?$',
  [routes.BOARD_OLD]: '^board/(.*?)$',
  [routes.BOARD_REFERRAL]: '^b/([^/]+)/([^/]+)/([^/]+)/recommend$',
  [routes.CARD]: '^c/([^/]+)(?:/(.*?))?$',
  [routes.CARD_AND_BOARD_OLD]: '^card/board/(?:([^/]+)/)?([^/]+)/([^/]+)$',
  [routes.CARD_OLD]: '^card/(?:([^/]+)/)?([^/]+)/([^/]+)$',
  [routes.CREATE_FIRST_BOARD]: '^create-first-board(?:\\?(.*?))?$',
  [routes.CREATE_FIRST_TEAM]: '^create-first-team$',
  [routes.DOUBLE_SLASH]: '^/(.*?)$',
  [routes.ENTERPRISE_ADMIN_TAB]: '^e/([^/]+)/admin/(.*?)$',
  [routes.ENTERPRISE_ADMIN]: '^e/([^/]+)/admin$',
  [routes.ERROR_PAGE]: '^(.*?)$',
  [routes.GO]: '^go/(.*?)$',
  [routes.INVITE_ACCEPT_BOARD]: '^invite/accept-board$',
  [routes.INVITE_ACCEPT_TEAM]: '^invite/accept-team$',
  [routes.MEMBER_ACTIVITY]: '^([^/]+)/activity$',
  [routes.MEMBER_ALL_BOARDS]: '^([^/]+)/boards$',
  [routes.MEMBER_CARDS_FOR_ORG]: '^([^/]+)/cards/([^/]+)$',
  [routes.MEMBER_CARDS]: '^([^/]+)/cards$',
  [routes.MEMBER_HOME]: '^$',
  [routes.MEMBER_HOME_BOARDS]: '^([^/]+)/home$',
  [routes.MEMBER_NOTIFICATIONS]: '^([^/]+)/notifications$',
  [routes.MEMBER_TASKS]: '^([^/]+)/tasks$',
  [routes.ORGANIZATION_BY_ID]: '^org/([^/]+)$',
  [routes.ORGANIZATION_EXPORT]: '^([^/]+)/export$',
  [routes.ORGANIZATION_FREE_TRIAL]: '^([^/]+)/free-trial$',
  [routes.ORGANIZATION_GUESTS]: '^([^/]+)/members/guests$',
  [routes.ORGANIZATION_MEMBERS]: '^([^/]+)/members$',
  [routes.ORGANIZATION_MEMBER_CARDS]: '^([^/]+)/([^/]+)/cards$',
  [routes.ORGANIZATION_POWERUPS]: '^([^/]+)/power-ups$',
  [routes.ORGANIZATION_TABLES]: '^([^/]+)/tables$',
  [routes.POWER_UP_ADMIN]: '^power-ups/admin(?:/([^/]+))?(?:/)?$',
  [routes.POWER_UP_EDIT]: '^power-ups/([^/]+)/edit(?:/([^/]+))?(?:/)?$',
  [routes.POWER_UP_PUBLIC_DIRECTORY]:
    '^power-ups(?:/([^/]+))?(?:/([^/]+))?(?:/)?$',
  [routes.PROFILE]: '^([^/]+)/profile$',
  [routes.SEARCH]: '^search(?:\\?(.*?))?$',
  [routes.SELECT_ORG_TO_UPGRADE]: '^select-org-to-upgrade$',
  [routes.SELECT_TEAM_TO_UPGRADE]: '^select-team-to-upgrade$',
  [routes.SHORTCUTS]: '^shortcuts$',
  [routes.SHORTCUTS_OVERLAY]: '^shortcuts/overlay$',
  [routes.TEAM_HIGHLIGHTS]: '^([^/]+)/highlights$',
  [routes.TEAM_REPORTS]: '^([^/]+)/reports$',
  [routes.TEMPLATES]: '^templates(?:/([^/]+))?(?:/([^/]+))?(?:/)?$',
  [routes.TEMPLATES_RECOMMEND]:
    '^templates(?:/([^/]+))?(?:/([^/]+))?(?:/([^/]+))?/recommend(?:/)?$',
  [routes.TO]: '^to/(.*?)$',
  [routes.USER_OR_ORG]: '^([^/]+)(?:/)?$',
  [routes.WELCOME]: '^welcome$',
};

const applyMatchers = (url: string): string => {
  // let's remove the starting slash to allow our matchers to use ^ properly
  const partialUrl = url.substr(1, url.length);

  for (const route of routes.ORDERED_ROUTE_LIST) {
    if (partialUrl.match(matchers[route])) {
      return route;
    }
  }

  return routes.ERROR_PAGE;
};

export const scrubUrl = (url: string) => {
  let parsedUrl;
  try {
    // This is a little bit of a hack, it's really hard to actually get
    // `url-parse` to throw an error, so instead we set the default base URL to
    // be the fallback - if parsing fails the fallback URL will be the parsed URL
    parsedUrl = urlParse(url, routes.ERROR_PAGE);
  } catch (ex) {
    // we can't log the original URL or message because we could end up with
    // UGC, so we return a safe fallback URL so we don't lose the error
    return routes.ERROR_PAGE;
  }

  const partialUrl = `${parsedUrl.pathname}${parsedUrl.query}`;
  const result = applyMatchers(partialUrl);

  return parsedUrl.protocol && parsedUrl.host
    ? `${parsedUrl.protocol}//${parsedUrl.host}/${result}`
    : `/${result}`;
};
